import createIcon from '../../createIcon';

/**
 * @component @name NotListedLocation
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMkM4LjE0IDIgNSA1LjE0IDUgOUM1IDE0LjI1IDEyIDIyIDEyIDIyQzEyIDIyIDE5IDE0LjI1IDE5IDlDMTkgNS4xNCAxNS44NiAyIDEyIDJaTTEyLjg4IDE1Ljc1SDExLjEzVjE0SDEyLjg4VjE1Ljc1Wk0xMi44OCAxMi44OEgxMS4xM0MxMS4xMyAxMC4wNCAxMy43NSAxMC4yNiAxMy43NSA4LjVDMTMuNzUgNy41NCAxMi45NiA2Ljc1IDEyIDYuNzVDMTEuMDQgNi43NSAxMC4yNSA3LjU0IDEwLjI1IDguNUg4LjVDOC41IDYuNTcgMTAuMDcgNSAxMiA1QzEzLjkzIDUgMTUuNSA2LjU3IDE1LjUgOC41QzE1LjUgMTAuNjkgMTIuODggMTAuOTEgMTIuODggMTIuODhaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const NotListedLocation = createIcon('NotListedLocation', [
  [
    'path',
    {
      d: 'M12 2C8.14 2 5 5.14 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.14 15.86 2 12 2ZM12.88 15.75H11.13V14H12.88V15.75ZM12.88 12.88H11.13C11.13 10.04 13.75 10.26 13.75 8.5C13.75 7.54 12.96 6.75 12 6.75C11.04 6.75 10.25 7.54 10.25 8.5H8.5C8.5 6.57 10.07 5 12 5C13.93 5 15.5 6.57 15.5 8.5C15.5 10.69 12.88 10.91 12.88 12.88Z',
      key: '11w9p7',
    },
  ],
]);

export default NotListedLocation;
